var developmentMode = false;

if (developmentMode) {
    // development
    var server = 'http://localhost:8090';
} else {
    // production
    var server = 'https://myafs.fleetmt.com';
}

const Config = {
    BASE_URL: server + '/api',
    developmentMode: developmentMode,
}

export default Config;